import { CONTENTFUL_LOCALE_BY_SLUG } from '../../locale/constants';
import { dictionaries, localDictionaries } from '../store';
import { clearLookupsCache } from '../lookups';
import { getContentfulDeliveryConfig } from './config';
import { fetchContentfulEntries } from './fetch';
import { cloneJson, deepMerge, mapContentfulEntries } from './map';

function applyLocalDictionary(locale) {
  dictionaries[locale] = cloneJson(localDictionaries[locale] || localDictionaries.en);
  clearLookupsCache(locale);
}

/** Remote Contentful is the live source. Local src/content is the fallback. */
export async function syncContentfulLocale(locale, signal) {
  const contentfulLocale = CONTENTFUL_LOCALE_BY_SLUG[locale];
  if (!contentfulLocale) {
    applyLocalDictionary(locale);
    return false;
  }

  if (!getContentfulDeliveryConfig()) {
    applyLocalDictionary(locale);
    if (typeof console !== 'undefined') {
      console.warn(
        'Contentful delivery is not configured (REACT_APP_CONTENTFUL_SPACE / REACT_APP_CONTENTFUL_DELIVERY_TOKEN). Using local src/content.'
      );
    }
    return false;
  }

  try {
    const payload = await fetchContentfulEntries(contentfulLocale, signal);
    if (!payload) {
      applyLocalDictionary(locale);
      return false;
    }
    const overlay = mapContentfulEntries(payload);
    const base = cloneJson(localDictionaries[locale] || localDictionaries.en);
    dictionaries[locale] = deepMerge(base, overlay);
    clearLookupsCache(locale);
    return true;
  } catch (error) {
    if (error?.name === 'AbortError') return false;
    applyLocalDictionary(locale);
    if (typeof console !== 'undefined') {
      console.warn('Contentful copy fetch failed; using local src/content dictionaries.', error);
    }
    return false;
  }
}
